/** Configuration File
 **/

module.exports = {
    backend: 'http://tagmanager.mwancloud.com:5000/'
}
